import { type DetailedHTMLProps, type FC, type HTMLAttributes } from 'react';

import { DATA_AS_NAV_TAB_ATTR } from '../Header/helpers';

type TabSectionProps = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> & {
  sectionTabTitle: string;
  id: string;
};

export const TabSection: FC<TabSectionProps> = ({ sectionTabTitle, ...restProps }) => (
  <section {...restProps} {...{ [DATA_AS_NAV_TAB_ATTR]: sectionTabTitle }}></section>
);
